module.exports = __webpack_public_path__ + "static/favicon-4a88de6a339827e09b6c6b5b000df461.ico";